export const intToMoney = (number) => {
    let money = new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(number);

    //remove number after comma
    money = money.split(',');
    return money[0];
}